import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { Typography } from "antd";
import { LoginWrapper } from "../Auth/style";
import wayabankLogo from "../../assets/images/newlog.svg";
import { customBaseUrl, httpGet, httpPost } from "../../store/http";
import { NotificationManager } from "react-notifications";
import GlassCard from "../../components/premium/GlassCard";
import PremiumButton from "../../components/premium/PremiumButton";
import OtpInput from "react-otp-input";

const { Title, Text, Paragraph } = Typography;

const AdminAccountVerification = () => {
  const [inputText, setInputText] = useState("");
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const emailOrPhone = searchParams.get("emailOrPhone");

  const sentOtp = useCallback(async () => {
    try {
      let response = await httpGet(
        `${customBaseUrl.authUrl}/api/v1/auth/resend-otp/signup/${emailOrPhone}`
      );
      if (response.status === true) {
        NotificationManager.success(response.message, "Success", 3000);
      } else {
        NotificationManager.error(response.message, "Error");
      }
    } catch (error) {
      NotificationManager.error("Failed to send OTP", "Error");
    }
  }, [emailOrPhone]);

  useEffect(() => {
    const session_var = sessionStorage.getItem("activation_request_trials");
    if (session_var === "6B86B273FF34FCE19D6B804EFF5A3F5747ADA4EAA22F1D49C01E52DDB7875B4B") {
      sentOtp().finally(() => {
        sessionStorage.removeItem("activation_request_trials");
      });
    }
  }, [sentOtp]);

  const handleVerifyOtp = async () => {
    if (inputText.length !== 6) {
      NotificationManager.warning("Please enter a valid 6-digit OTP", "Warning");
      return;
    }
    setLoading(true);
    try {
      let response = await httpPost(
        `${customBaseUrl.authUrl}/api/v1/auth/verify-otp`,
        {
          "otp": inputText,
          "phoneOrEmail": emailOrPhone
        }
      );
      setLoading(false);
      if (response.status === true) {
        NotificationManager.success(response.message, "Verified");
        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } else {
        NotificationManager.error(response.message, "Verification Failed");
      }
    } catch (error) {
      setLoading(false);
      NotificationManager.error("Something went wrong during verification", "Error");
    }
  };

  return (
    <LoginWrapper>
      <div className="auth-container" style={{ justifyContent: 'center' }}>
        <div className="auth-form-section" style={{ width: '500px' }}>
          <div className="logo-container" style={{ textAlign: 'center', marginBottom: '32px' }}>
            <img src={wayabankLogo} alt="WayaBank Logo" />
          </div>
          
          <GlassCard padding="48px" radius="24px">
            <Title level={2} style={{ textAlign: 'center', marginBottom: '12px', fontWeight: 600 }}>
              Verify Account
            </Title>
            <Paragraph style={{ textAlign: 'center', marginBottom: '32px', color: 'var(--text-muted)' }}>
              Enter the OTP sent to <strong>{emailOrPhone}</strong> to activate your admin account.
            </Paragraph>

            <div style={{ marginBottom: '40px' }}>
               <OtpInput
                value={inputText}
                onChange={setInputText}
                numInputs={6}
                renderSeparator={<span style={{ width: '12px' }}></span>}
                renderInput={(props) => (
                  <input 
                    {...props} 
                    style={{ 
                      width: '48px', 
                      height: '56px', 
                      fontSize: '24px', 
                      textAlign: 'center', 
                      borderRadius: '12px', 
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      background: 'rgba(255, 255, 255, 0.05)',
                      color: 'var(--text-primary)',
                      outline: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--waya-red)'}
                    onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)'}
                  />
                )}
                containerStyle={{ justifyContent: 'center' }}
              />
            </div>

            <PremiumButton 
              type="primary" 
              onClick={handleVerifyOtp} 
              block 
              size="large" 
              loading={loading}
              style={{ height: '48px' }}
            >
              Verify & Activate
            </PremiumButton>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <Text style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                Didn't get the code?{' '}
                <span 
                  onClick={sentOtp} 
                  style={{ color: 'var(--waya-red)', cursor: 'pointer', fontWeight: 500 }}
                >
                  Resend OTP
                </span>
              </Text>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
              <a href="/login" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                Back to Sign in
              </a>
            </div>
          </GlassCard>
        </div>
      </div>
    </LoginWrapper>
  );
};

export default AdminAccountVerification;
